const progressBar = document.querySelector<HTMLElement>('.post-progress__bar')

const update = () => {
  requestAnimationFrame(() => {
    if (progressBar) {
      // calculate progress based on height of the viewport and the height of the page
      const progress =
        (window.scrollY /
          (document.documentElement.scrollHeight - window.innerHeight)) *
        100
      progressBar.style.width = `${progress}%`
    }
  })
}

window.addEventListener('scroll', update, { passive: true })

update()
